<div class="dipswitch-wrapper">
  <div class="table-container">
    <div class="table-header">
      <div class="header-cell">
        <span class="header-label">DIPSwitch setting</span>
        <span class="header-label">number</span>
      </div>
      <div class="header-cell">
        <span class="header-label">Current</span>
        <span class="header-unit">mA</span>
      </div>
    </div>
    <div class="table-body">
      @for (setting of settings; track setting.key) {
        <div class="table-row">
          <div class="row-cell setting-number" [id]="setting.key + '-label'">{{ setting.index }}</div>
          <div class="row-cell">
            <input type="number" [value]="setting.displayValue" step="1"
              class="input-text form-control signifyBookmd" [id]="setting.key + '-input'"
              [attr.aria-label]="'Current at DIPSwitch setting ' + setting.index"
              (input)="onFieldInput($event.target, setting.key)"
              (blur)="onFieldBlur($event.target, setting.key)"
              (keypress)="numberOnly($event)"
              [ngClass]="{'myStyle': inputError[setting.key] === true}" />
          </div>
        </div>
      }
    </div>
  </div>
</div>

<div class="note-banner" id="dipswitch-note">
  <span class="note-label" id="dipswitch-note-label">Note:</span>
  <span class="note-text" id="dipswitch-note-description">When AOC is enabled, the DIPSwitch setting is disabled.</span>
</div>
